<template>
  <div id="app">
    <el-container>
      <el-header
        class="header_index"
        style="box-shadow: 0px 0px 5px 2px rgb(72 72 72 / 20%)"
      >
        <div class="navigation">
          <el-row>
            <el-col :span="4">
              <div class="index_title">联盟校管理</div>
            </el-col>
            <el-col :span="16" style="">
              <el-menu
                :default-active="activeIndex"
                class="el-menu-demo"
                mode="horizontal"
                background-color="#545c64"
                text-color="#fff"
                active-text-color="#ffd04b"
                @select="handleSelect"
              >
                <el-menu-item
                  v-for="item in navTion"
                  :key="item.id"
                  :index="item.html"
                  >{{ item.name }}</el-menu-item
                >
              </el-menu>
            </el-col>
            <el-col :span="4" class="heder_right">
              <el-popover placement="bottom" trigger="hover" width="150">
                <!-- <el-button size="small" @click="logout">退出登录</el-button> -->
                <div class="operation">
                  <ul>
                    <li @click="modifyPwd">修改密码</li>
                    <li @click="logout" class="logout">退出登录</li>
                  </ul>
                </div>
                <el-button style="color: #fff" type="text" slot="reference">{{
                  name
                }}</el-button>
              </el-popover>
            </el-col>
          </el-row>
        </div>
      </el-header>
      <el-container v-if="!flag" class="container_index">
        <el-aside class="aside_index" width="220px"
          ><el-card
            :body-style="{ padding: '20px 0px' }"
            style="min-height: 768px; background-color: #e8ebef"
          >
            <el-menu
              :default-active="activeIndexA"
              class="el-menu-demo"
              style="background-color: #e8ebef"
              @select="handleSelectA"
              router
            >
              <el-menu-item
                v-for="item in sideMenu"
                :key="item.id"
                :index="item.html"
                >{{ item.name }}</el-menu-item
              >
            </el-menu>
          </el-card></el-aside
        >
        <el-main style="padding: 10px">
          <el-card class="main_index">
            <keep-alive>
              <router-view v-if="$route.meta.keepAlive"></router-view>
            </keep-alive>
            <router-view v-if="!$route.meta.keepAlive"></router-view>
          </el-card>
        </el-main>
      </el-container>
      <el-main class="main_indexs" v-else style="padding: 10px">
        <div>
          <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
          </keep-alive>
          <router-view v-if="!$route.meta.keepAlive"></router-view>
        </div>
      </el-main>
    </el-container>
    <el-dialog
      :before-close="cancelPwd"
      title="修改密码"
      width="500px"
      :visible.sync="dialogFormVisible"
    >
      <el-form ref="passform" :model="form" label-width="100px">
        <el-form-item
          label="原始密码"
          prop="oldPassword"
          :rules="[
            { required: true, message: '密码不能为空', trigger: 'blur' },
            { min: 6, message: '密码必须为6位以上', trigger: 'blur' },
          ]"
        >
          <el-input
            size="small"
            style="width: 320px"
            v-model="form.oldPassword"
            type="password"
          />
        </el-form-item>
        <el-form-item
          prop="newPassword"
          label="新密码"
          :rules="[
            { required: true, message: '密码不能为空', trigger: 'blur' },
            { min: 6, message: '密码必须为6位以上', trigger: 'blur' },
          ]"
        >
          <el-input
            style="width: 320px"
            size="small"
            v-model="form.newPassword"
            type="password"
          />
        </el-form-item>
        <el-form-item
          label="确认新密码"
          prop="newPassword1"
          :rules="[
            {
              validator: checkPassword,
              required: true,
              trigger: 'blur',
            },
            { min: 6, message: '密码必须为6位以上', trigger: 'blur' },
          ]"
        >
          <el-input
            size="small"
            style="width: 320px"
            v-model="form.newPassword1"
            type="password"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancelPwd">取 消</el-button>
        <el-button size="small" type="primary" @click="submitpass"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  treeByRole,
  usercenterinfo,
  UserLogout,
  modifyPassWord,
} from "@/api/home";
export default {
  data() {
    return {
      roleId: localStorage.getItem("roleId"),
      navTion: [],
      activeIndex: "",
      activeIndexA: "",
      sideMenu: [],
      name: "",
      flag: false,
      form: {
        oldPassword: "",
        newPassword: "",
        newPassword1: "",
      },
      dialogFormVisible: false,
      rules: {
        oldPassword: [
          { required: true, message: "请输入原密码", trigger: "blur" },
          { min: 4, message: "长度最低4个字符", trigger: "blur" },
        ],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { min: 4, message: "长度最低4个字符", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.usercenterinfos();
  },
  methods: {
    // 获取当前用户信息
    usercenterinfos() {
      usercenterinfo().then((res) => {
        localStorage.setItem("groupId", res.data.data.groupInfo.groupId);
        localStorage.setItem("name", res.data.data.groupInfo.name);
        localStorage.setItem("id", res.data.data.groupInfo.id);
        localStorage.setItem("isManager", res.data.data.groupInfo.isManager);
        this.name = res.data.data.groupInfo.name;
        this.treeByRoles();
      });
    },
    // 退出登录
    logout() {
      UserLogout().then((res) => {
        if (res.data.code == 0) {
          localStorage.clear();
          this.$router.push("/");
        }
      });
    },
    treeByRoles() {
      this.navTion = localStorage.getItem('navTion');
      if(!this.navTion || this.navTion === 'null'){
        treeByRole({
          roleId: this.roleId,
        }).then((res) => {
          this.navTion = res.data.data;
          localStorage.setItem('navTion', JSON.stringify(this.navTion));
          this.initNav();
        });
      } else {
        this.navTion = JSON.parse(this.navTion)
        this.initNav();
      }
    },
    initNav() {
      let activeIndex = localStorage.getItem("activeIndex");
      if (activeIndex) {
        this.activeIndex = activeIndex;
        this.navTion.forEach((item) => {
          if (item.html == this.activeIndex) {
            this.sideMenu = item.menuList;
          }
        });
      } else {
        this.activeIndex = this.navTion[0].html;
        localStorage.setItem("activeIndex", this.activeIndex);
        if (!this.navTion[0].isLeaf) {
          this.sideMenu = this.navTion[0].menuList;
        }
      }
      // this.sideMenu = res.data.data[4].menuList;

      let activeIndexA = localStorage.getItem("activeIndexA");
      if (activeIndexA) {
        this.activeIndexA = activeIndexA;
        // this.$router.push(this.activeIndexA);
      } else {
        if (!this.navTion[0].isLeaf) {
          this.activeIndexA = this.sideMenu[0].html;
          localStorage.setItem("activeIndexA", this.activeIndexA);
          // this.$router.push(this.activeIndexA);
          this.flag = false;
          return false;
        }
        this.flag = true;
        // this.$router.push(this.activeIndex);
      }
    },
    // 一级路由
    handleSelect(idx) {
      this.activeIndex = idx;
      localStorage.setItem("activeIndex", this.activeIndex);
      this.navTion.forEach((item) => {
        if (item.html == this.activeIndex) {
          if (!item.isLeaf) {
            this.sideMenu = item.menuList;
            this.activeIndexA = this.sideMenu[0].html;
            localStorage.setItem("activeIndexA", this.activeIndexA);
            this.$router.push(this.activeIndexA);
            this.flag = false;
          } else {
            localStorage.removeItem("activeIndexA");
            this.$router.push(this.activeIndex);
            this.flag = true;
          }
        }
      });
      this.treeByRoles();
    },
    // 二级路由
    handleSelectA(idx) {
      this.activeIndexA = idx;
      localStorage.setItem("activeIndexA", this.activeIndexA);
    },
    // 修改密码
    modifyPwd() {
      this.dialogFormVisible = true;
    },
    // 二次密码效验
    checkPassword(rule, value, callback) {
      if (!value) {
        return callback(new Error("二次密码不能为空"));
      } else {
        if (this.form.newPassword !== this.form.newPassword1) {
          return callback(new Error("两次密码必须输入一致"));
        } else {
          callback();
        }
      }
    },
    // 密码提交
    submitpass() {
      this.$refs.passform.validate((valid) => {
        if (valid) {
          this.ApiModifyPassByOld();
        } else {
          this.$message.error("请检查信息是否填写正确");
          return false;
        }
      });
    },
    ApiModifyPassByOld() {
      const { form } = this;
      modifyPassWord({ ...form }).then((res) => {
        if (res.data.code == 0) {
          this.$message.success("修改成功,请使用先密码登录");
          this.dialogFormVisible = false;
          this.$router.push("/");
          localStorage.clear();
          this.$refs.passform.resetFields();
        }
      });
    },
    // 取消密码设置
    cancelPwd() {
      this.dialogFormVisible = false;
      this.$refs.passform.resetFields();
    },
  },
};
</script>
<style scoped>
.index_title {
  font-size: 22px;
  font-weight: 600;
  width: 100%;
  height: 60px;
  color: #fff;
  line-height: 60px;
  text-align: center;
}
.header_index {
  height: 60px;
  width: 100%;
  background-color: #545c64;
}
.navigation {
  max-width: 1440px;
  height: 60px;
  margin: 0 auto;
}
.container_index {
  width: 100%;
  margin: 10px auto;
}
.aside_index {
  /* height: 100%;*/
  min-height: 700px;
  padding: 10px;
}
.heder_right {
  text-align: center;
  line-height: 60px;
}
.operation li {
  list-style: none;
  width: 100%;
  line-height: 30px;
  height: 30px;
  cursor: pointer;
  margin-bottom: 10px;
}
li:hover {
  background-color: #e1efff;
  border-radius: 4px;
}
.operation .logout {
  background-color: #409eff;
  border-radius: 4px;
  color: #fff;
}
.main_index {
  min-height: 768px;
}
.main_indexs {
  background: linear-gradient(to bottom, #f7fbff 0%, #fcfdff 100%);
  min-height: 900px;
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue